import { date2usDotDateTime } from "helpers";
import React from "react";

import styles from './DateTimeSelect.module.scss';

interface IDateTimeSelect {
  value: string;
  setValue: (value: string) => void;
}

/**
 * Formats a date string/ISO string to the format required by datetime-local input
 * datetime-local requires: YYYY-MM-DDTHH:MM (no seconds, no timezone)
 */
const formatForDateTimeLocal = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';

    // Format as YYYY-MM-DDTHH:MM in local time
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } catch {
    return '';
  }
};

const DateTimeSelect = ({ value, setValue }: IDateTimeSelect) => {
  const timeInputRef = React.useRef<HTMLInputElement>(null);

  // Convert the incoming value to datetime-local format
  const formattedValue = formatForDateTimeLocal(value);

  return (
    <>
      <p
        className={styles.timeText}
        // onClick={() => timeInputRef.current?.showPicker()}
      >
        {value ? date2usDotDateTime(value) : 'Click to Select'}
      </p>
      <input
        ref={timeInputRef}
        value={formattedValue}
        onChange={(e) => setValue(e.target.value)}
        style={{ opacity: 0, height: 0, margin: 0, padding: 0 }}
        type="datetime-local"
      />
    </>
  )
}

export default DateTimeSelect